module.exports = __webpack_public_path__ + "img/bg_circle.ea2a814f.png";